import { h } from "omi";

import { IconProps } from "@/wc/components";

export function PencilIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={width} height={height}>
      <path
        d="m2.5 21.4998 5.54927-2.1343c.35494-.1365.53241-.2048.69845-.2939.14748-.0792.28808-.1706.42032-.2732.14888-.1155.28333-.25.55224-.5189L21 6.99982c1.1046-1.10457 1.1046-2.89544 0-4.00001-1.1045-1.10456-2.8954-1.10457-4 0L5.72028 14.2795c-.2689.2689-.40336.4034-.51889.5523a2.99656 2.99656 0 0 0-.27316.4203c-.08912.166-.15738.3435-.2939.6985L2.5 21.4998Zm0 0 2.05812-5.351c.14728-.3829.22091-.5744.34722-.6621.11038-.0766.24696-.1056.37896-.0804.15103.0288.29608.1739.58618.464l2.25909 2.2591c.2901.2901.43515.4351.46399.5861a.500062.500062 0 0 1-.08042.379c-.08769.1263-.27915.1999-.66207.3472L2.5 21.4998Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
